import './SchoolClosePage.scss'

import { Modal } from 'antd'
import CenteredLayout from 'components/centered-layout/CenteredLayout'
import { Okul } from 'gql/StaticTypes'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { useSinifUrunleriQuery } from '../../gql/GeneratedGraphqlTypes'

interface SchoolClosePageProps {
  okul: Okul
}

function SchoolClosePage({ okul }: SchoolClosePageProps) {
  const { classId } = useParams()
  let sinif = parseInt(classId!)
  const { data } = useSinifUrunleriQuery({
    variables: {
      slug: okul!.slug!,
      sinif_id: sinif! || 1,
    },
  })

  const [isModalVisible, setIsModalVisible] = useState(true)

  const showModal = () => {
    setIsModalVisible(true)
  }

  useEffect(() => {
    showModal()
  }, [])

  return (
      <CenteredLayout className="modal-ayar">
        { data?.okul?.sinif?.kapali_uyarisi ? (
            <Modal title="Sınıfımız Henüz Satışa Açılmamıştır!" open={isModalVisible} className="custom-modal" closable={true}
                   onCancel={() => setIsModalVisible(false)}>
              <p className="okul-yazi">{data?.okul.sinif.kapali_uyarisi}</p>
            </Modal> 
        ) :okul.uyari ? (
            <Modal title="Okul Listeleriniz şu anda satışa kapalıdır." open={isModalVisible} className="custom-modal"   closable={true}
                   onCancel={() => setIsModalVisible(false)}>
              <p className="okul-yazi" dangerouslySetInnerHTML={{ __html: okul.uyari.replace(/&lt;/g, '<').replace(/&gt;/g, '>') }} />
            </Modal>
        ) : null}
      </CenteredLayout>

  )
}

export default SchoolClosePage
